import { render, staticRenderFns } from "./cmpbaixartitulosreceber.vue?vue&type=template&id=02ddcbf0&"
import script from "./cmpbaixartitulosreceber.vue?vue&type=script&lang=js&"
export * from "./cmpbaixartitulosreceber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports